export default "__VITE_ASSET__u1NXxR8G__"